module.exports = __webpack_public_path__ + "47a838ef265001ed38b21af031a525d4.png";